 import lang from "@/views/modules/Administration/language/en";
import breadcrumbs from "@/views/modules/Administration/MenuList.vue";
import alert from "@/views/shared/notify/Alert.vue";

export default {
    name: "unique",
    
    components: {
        breadcrumbs,
        alert,
    },
    data() {
        return {
            lang:[],
            defaultpath:null,
            page: 1,
            search: '',
            sort: {
                order: 'asc',
                column: 'date_entered',
                relRef:'',
            },
            perPage: 10,
            listData:[],
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0
            },
            sequences:{
                id:null,
                name:null,
                sequence_type:null,
                period:null,
                seq_no:null,
                field_name:null,
                prefix:null,
                date_field:null,
                branch_id:null
            },
            branch_list:[],
            error_msg:'',
            table_head: [{
                label: lang.LBL_MODULE_NAME,
                isSort: true,
                field_name: 'name'
            },
            {
                label: lang.LBL_FIELD,
                relRef: 'notifications_users',
                isSort: true,
                field_name: 'field_name'
            },
            {
                label: lang.LBL_IDENTIFIERS,
                isSort: true,
                field_name: 'sequence_type'
            },
            {
                label: lang.LBL_PREFIX,
                isSort: true,
                field_name: 'prefix'
            },
            {
                label: lang.LBL_SEQUENCE,
                isSort: true,
                field_name: 'seq_no'
            },
            {
                label: lang.LBL_DATE_FIELD,
                isSort: true,
                field_name: 'date_field'
            },
            {
                label: lang.LBL_ACTION,
            }
            ]
        }
     },
    mounted() {
        this.lang = lang;
        this.loadSequence();
        this.loadBranch();
    },
    methods: {
        sortBy(field, relRef) {
            if (this.sort.column === field) {
                this.sort.order = this.sort.order === 'asc' ? 'desc' : 'asc';
            } else {
                this.sort.order = 'asc';
            }
            this.sort.column = field;
            this.sort.relRef = relRef;
            this.loadSequence()
        },
        changePage(page) {
            const self = this;
            if ((page > 0) && (page <= self.pagination.totalPages) && (page !== self.page)) {
                self.page = page;
                self.loadSequence();
            }
        },
        changeSort() {
            const self = this;
            if (self.sort.order === 'asc') {
                self.sort.order = 'desc';
            } else if (self.sort.order === 'desc') {
                self.sort.order = 'asc';
            }
            self.loadSequence();
        },
        loadSequence(){
            const self = this;
            let branch_id = null;
            branch_id = self.sequences.branch_id;
            window.currentAction = 'list';
                axios.get('api/modules/sequences', {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: branch_id,
                    perPage: self.perPage,
                }
            }).then(function (response) {
                self.listData = response.data.items;
               
                self.pagination = response.data.pagination;
                if (self.pagination.totalPages < self.pagination.currentPage) {
                    self.page = self.pagination.totalPages;
                    self.loadSequence();
                }
            }).catch(function () {
                console.log("error");
            });
        },
        loadBranch(){
            //branch_list
            const self = this;
            axios.post('api/modules/branchs/getBranch',{'getBranch':true}).then(function(response){
                self.branch_list = response.data;
                
            }).catch(function(){
                console.log("Error");
            })
        },
        saveSequence(){
            const self = this;
            let is_submit = true;
            document.querySelectorAll(".required").forEach(el=>el.remove());
            
            if(self.sequences.name == null){
                let error_el = document.getElementById("name");
                error_el.insertAdjacentHTML("afterend", '<span class="required">This field is required</span>');
                is_submit = false;
            }
            if(self.sequences.sequence_type == null){
                let error_el = document.getElementById("sequence_type");
                error_el.insertAdjacentHTML("afterend", '<span class="required">This field is required</span>');
                is_submit = false;
            }
            if(self.sequences.period == null){
                let error_el = document.getElementById("period");
                error_el.insertAdjacentHTML("afterend", '<span class="required">This field is required</span>');
                is_submit = false;
            }
            if(self.sequences.seq_no == null){
                let error_el = document.getElementById("seq_no");
                error_el.insertAdjacentHTML("afterend", '<span class="required">This field is required</span>');
                is_submit = false;
            }
            if(self.sequences.field_name == null){
                let error_el = document.getElementById("field_name");
                error_el.insertAdjacentHTML("afterend", '<span class="required">This field is required</span>');
                is_submit = false;
            }
            if(self.sequences.date_field == null){
                let error_el = document.getElementById("date_field");
                error_el.insertAdjacentHTML("afterend", '<span class="required">This field is required</span>');
                is_submit = false;
            }
            if(self.sequences.branch_id ==null){
                let error_el = document.getElementById("branch_id");
                error_el.insertAdjacentHTML("afterend", '<span class="required">This field is required</span>');
                is_submit = false;
            }
            
            if(is_submit){
                self.error_msg = "";
            axios.post('api/modules/sequences/saveSequence', self.sequences).then(function(response){
                
                self.$refs.notifyMsg.showAlert('Success',response.data.message);
                self.$refs.sequenceForm.reset(); // This will clear that form
                self.sequences.id = null;
                self.sequences.name = null;
                self.sequences.sequence_type = null;
                self.sequences.period = null;
                self.sequences.seq_no = null;
                self.sequences.field_name = null;
                self.sequences.prefix = null;
                self.sequences.date_field = null;
                self.loadSequence();
            }).catch(function () {
                console.log("Error in form submition");
            });
        }else if(self.sequences.id != null){
            self.error_msg = "";
            axios.post('api/modules/sequences/updateSequence', self.sequences).then(function(response){
                
                self.$refs.notifyMsg.showAlert('Success' ,response.data.message);
                self.$refs.sequenceForm.reset(); // This will clear that form
                self.sequences.id = null;
                self.sequences.name = null;
                self.sequences.sequence_type = null;
                self.sequences.period = null;
                self.sequences.seq_no = null;
                self.sequences.field_name = null;
                self.sequences.prefix = null;
                self.sequences.date_field = null;
                self.loadSequence();
            }).catch(function () {
                console.log("Error in form submition");
            });
        }else{
           // console.log("Error in form submition");
           self.error_msg = "Error in form submition";
        }
        },
        editSequence(record){
            const self = this;
            axios.post('api/modules/sequences/getSequence', {'record':record}).then(function(response){
                self.sequences.id = response.data.id;
                self.sequences.name = response.data.name,
                self.sequences.sequence_type = response.data.sequence_type,
                self.sequences.period = response.data.period,
                self.sequences.seq_no = response.data.seq_no,
                self.sequences.field_name = response.data.field_name,
                self.sequences.prefix = response.data.prefix,
                self.sequences.date_field = response.data.date_field
            });
        },
        removeSequence(record){
            const self = this;
            axios.post('api/modules/sequences/remove', {'delete_id':record}).then(function(response){
                self.loadSequence();
            }).catch(function(){
                console.log('Error in remove function');
                self.$refs.notifyMsg.showAlert('Error', 'Error during operation');
            })
        },
        clear(){
                const self = this;
                self.$refs.sequenceForm.reset(); // This will clear that form
                self.sequences.id = null;
                self.sequences.name = null;
                self.sequences.sequence_type = null;
                self.sequences.period = null;
                self.sequences.seq_no = null;
                self.sequences.field_name = null;
                self.sequences.prefix = null;
                self.sequences.date_field = null;
        }
    },
}